import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBarsTwo2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBarsTwo2"><Path fillRule="evenodd" clipRule="evenodd" d="M2 7.5C2 7.22386 2.22386 7 2.5 7H21.5C21.7761 7 22 7.22386 22 7.5C22 7.77614 21.7761 8 21.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 16.5C2 16.2239 2.22386 16 2.5 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H2.5C2.22386 17 2 16.7761 2 16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBarsTwo2;
